import React, { useContext, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Pdf from "react-to-pdf";
import imagePath from "../../../CSS/imagePath";
import "./CertificateModal.css";
import { PDFExport } from "@progress/kendo-react-pdf";
import moment from "moment";
import "./CertificateModal.css";
import midDesign from "../../../../Assets/Images/audition/mid-design.png";
import companyLogo from "../../../../Assets/Images/audition/versetilo-gp.png";
import brandLogo from "../../../../Assets/Images/audition/logo.png";
import bg from "../../../../Assets/Images/audition/bg.png";
import sign from "../../../../Assets/Images/audition/bal_sign.png";
import text from "../../../../Assets/Images/audition/text.png";
// import midDesign from '../../../../Assets/Images/cer'
import { useEffect } from "react";
import { DynamicStar } from "react-dynamic-star";
import axios from "axios";
import { Markup } from "interweave";
import { serverInfo } from "../../../../App";

const CertificateModal = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const ref = React.createRef();
  const pdfExportComponent = useRef(null);
  const [certificateData, setCertificateData] = useState({});

  useEffect(() => {
    const { auditionId, roundInfoId } = props;
    axios
      .get(
        `/api/user/audition/getAuditionCertificateData/${auditionId}/${roundInfoId}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          
          setCertificateData(res.data.certificateData);
        }
      });
  }, [props.auditionId, props.roundInfoId]);

  const handleButtonClick = (event) => {
    pdfExportComponent.current.save();
  };
  return (
    <div className="myModalDiv">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="my-modal"
      >
        {certificateData?.certificateContent?.brand_logo && (
          <Modal.Body>
            <div onClick={props.onHide} className="d-flex justify-content-end">
              <div className="closeNotificationDrop text-center">X</div>
            </div>
            <div ref={ref} className="my-3">
              <PDFExport ref={pdfExportComponent} paperSize="A3">
                <div className="bgCertificateModal">
                  <div className="cert-container">
                    <div id="content2" className="cert">
                      <img src={bg} alt="" className="cert-bg" />
                      <div className="cert-content  m-0 p-0 ">
                        <div className="headerCert ">
                          <table className="tableCert w-100 ">
                            <tbody >
                              <tr>
                                <th className="thCert">
                                  <div
                                    className="Logo mt-2"
                                    style={{ textAlign: "left" }}
                                  >
                                    <img src={companyLogo} alt="" />
                                  </div>
                                </th>
                                <th>
                                  <div
                                    className="Logo mt-2"
                                    style={{ textAlign: "right" }}
                                  >
                                    <img src={brandLogo} alt="" />
                                  </div>
                                </th>
                              </tr>
                              
                            </tbody>
                          </table>
                        </div>
                        <div>

                        <center>
                         <img src={text} alt="" />
                        </center>
                          <h1
                            className="cirtificate-title mt-2"
                            style={{ fontSize: 25 }}
                          >
                            {certificateData?.certificateContent?.title}
                          </h1>
                        </div>
                        <span
                          style={{
                            fontSize: 15,
                            textTransform: "uppercase",
                            fontWeight: "bold",
                          }}
                        >
                          {certificateData?.certificateContent?.sub_title}
                        </span>
                        <br />
                        <span className="other-font">
                          <div className="text-img2">
                            <img src={midDesign} alt />
                          </div>
                        </span>
                        <br />
                        <span className="other-font" style={{ fontSize: 35 }}>
                          <span className="font-Name">
                            {certificateData?.user}
                          </span>
                        </span>
                        <br />
                        <br />
                        <small className="smallText">
                          <Markup
                            content={
                              certificateData?.certificateContent?.main_content
                            }
                          />
                        </small>
                        <br />
                        <br />
                        <div className="stars d-flex justify-content-center">
                          <DynamicStar
                            rating={certificateData?.starRating?.toFixed(1)}
                            width={30}
                            height={30}
                          />
                        </div>
                        <table className="d-flex justify-content-center">
                          <tbody>
                            <tr>
                              {certificateData?.stars?.length > 0 &&
                                certificateData?.stars.map((item, index) => {
                                  return (
                                    <th>
                                      <div className="signature">
                                        <div className="sign">
                                          <img src={item?.signature?item?.signature:sign} alt="" />
                                        </div>
                                        <span>{item.name}</span> <br />
                                        <small className="smallText">
                                          Judge
                                        </small>{" "}
                                        <br />
                                        <small className="smallText">
                                          Hello Super Stars
                                        </small>
                                      </div>
                                    </th>
                                  );
                                })}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </PDFExport>
            </div>

            <div className="text-center">
              {certificateData?.certificateContent?.company_logo && (
                <button className="btn btn-warning" onClick={handleButtonClick}>
                  Download
                </button>
              )}
            </div>
          </Modal.Body>
        )}
      </Modal>
    </div>
  );
};

export default CertificateModal;
